export default "__VITE_ASSET__0V2PLnIx__"